<template>
<div>
  <section id="summary" class="container">
    <div class="segment box">
      <h1 class="title is-uppercase has-text-centered">Turnovers</h1>
      <div class="small-box">
        <div class="columns">
          <div class="column is-half is-offset-one-quarter">
            <h2 class="subtitle has-text-centered">Game Totals</h2>
            <chart width="125%" type="bar" :options="apex_to_options" :series="apex_to_series" ref="apex_to_chart"></chart>
          </div>
        </div>
        <div class="columns">
          <div class="column is-half is-offset-one-quarter">
            <h2 class="subtitle has-text-centered">Powerplay</h2>
            <chart  type="bar" :options="apex_to_options" :series="apex_to_pp_series" ref="apex_to_pp_chart"></chart>
            <h2 class="subtitle has-text-centered">Short Handed - Clearances</h2>
            <chart type="bar" :options="apex_to_options" :series="apex_to_sh_series" ref="apex_to_sh_chart"></chart>
          </div>
        </div>
      </div>
      <div>
          <sort-table endpoint="https://devilsapi.roblutken.com/api/app/turnovers-per-period"
          :postData="[{
          team_id: 1,
          game_id: this.gameId
          }]"
          :selectedData="[
              {
                title: 'player',
                prop: 'player'
              },
              {
                title: 'P1 Total',
                prop: 'to_p1'
              },
              {
                title: 'P1 OZ',
                prop: 'to_p1_oz'
              },
              {
                title: 'P1 NZ',
                prop: 'to_p1_nz'
              },
              {
                title: 'P1 DZ',
                prop: 'to_p1_dz'
              },
              {
                title: 'P2 Total',
                prop: 'to_p2'
              },
              {
                title: 'P2 OZ',
                prop: 'to_p2_oz'
              },
              {
                title: 'P2 NZ',
                prop: 'to_p2_nz'
              },
              {
                title: 'P2 DZ',
                prop: 'to_p2_dz'
              },
              {
                title: 'P3 Total',
                prop: 'to_p3'
              },
              {
                title: 'P3 OZ',
                prop: 'to_p3_oz'
              },
              {
                title: 'P3 NZ',
                prop: 'to_p3_nz'
              },
              {
                title: 'P3 DZ',
                prop: 'to_p3_dz'
              },
              {
                title: 'P4 Total',
                prop: 'to_ot'
              },
              {
                title: 'Total',
                prop: 'to_total'
              },

          ]"  @dataLoaded="gameDataLoaded"></sort-table>
        </div>
    </div>
  </section>
</div>
</template>

<script>
import SortTable from './sort-table'
import VueApexCharts from 'vue-apexcharts'
import _ from 'lodash'
export default {
  props: {
    gameId: { type: Number, required: true },
    period: { type: Number, required: true }
  },
  components: {
    SortTable,
    'chart': VueApexCharts
  },
  data () {
    return {
      TurnoversChart: [],
      apex_to_series: [
        {
          name: 'Turnovers',
          data: []
        }
      ],
      apex_to_pp_series: [
        {
          name: 'Turnovers',
          data: []
        }
      ],
      apex_to_sh_series: [
        {
          name: 'Turnovers',
          data: []
        }
      ],
      apex_to_options: {
        width: '100em',
        height: '2000px',
        colors: ['#8b0505d1', '#000000'],
        chart: { type: 'bar', stacked: false },
        plotOptions: { bar: { horizontal: false } }
      }
    }
  },
  computed: {

  },
  watch: {
    endpoint: {
      handler: function (endpoint) {
        this.url = endpoint
      },
      immediate: true
    },
    gameId: {
      handler: function (postData) {
        // console.log('Post data updated: ' + JSON.stringify(this.postData))
        this.fetchTurnoversChart()
      },
      immediate: true
    }
  },
  methods: {
    gameDataLoaded () {
      console.log('Loaded')
    },
    filterChange () {
    },
    fetchTurnoversChart () {
      if (this.gameId !== 0) {
        this.$http
          .get(
            'https://devilsapi.roblutken.com/api/app/get/match-stats/turnovers/' + this.gameId + '/' + 0,
            { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
          )
          .then(
            response => {
              // console.log('Turnovers Data is ' + JSON.stringify(response.data))
              this.TurnoversChart = response.data
              let players = []
              let allSeries = []
              let playersSH = []
              let shSeries = []
              let playersPP = []
              let ppSeries = []
              let toEH = _.orderBy(this.TurnoversChart.home_players, function (o) {
                return o.total_eh + o.total_pp + o.total_sh
              }, ['desc'])
              let toPP = _.orderBy(this.TurnoversChart.home_players, function (o) {
                return o.total_pp
              }, ['desc'])
              let toSH = _.orderBy(this.TurnoversChart.home_players, function (o) {
                return o.total_sh
              }, ['desc'])
              for (var to of toEH) {
                // Totals
                let total = to.total_eh + to.total_pp + to.total_sh
                // console.log('Total for player: ' + to.player_id + 'Total:' + total + ' EH: ' + to.total_eh + ' PP ' + to.total_pp + ' SH ' + to.total_sh)
                allSeries.push(total)
                // this.apex_to_series[0].data.push(total)
                players.push(to.player_id)
              }
              for (var toP of toPP) {
                if (toP.total_pp > 0) {
                  playersPP.push(toP.player_id)
                  ppSeries.push(toP.total_pp)
                }
              }
              for (var toS of toSH) {
                if (toS.total_sh > 0) {
                  playersSH.push(toS.player_id)
                  shSeries.push(toS.total_sh)
                }
              }
              // console.log(allSeries)
              this.apex_to_series[0].data = allSeries
              this.apex_to_sh_series[0].data = shSeries
              this.apex_to_pp_series[0].data = ppSeries
              let newOptions = { xaxis: { categories: players } }
              this.$refs.apex_to_chart.updateOptions(newOptions)
              let newOptionsPP = { xaxis: { categories: playersPP } }
              this.$refs.apex_to_pp_chart.updateOptions(newOptionsPP)
              let newOptionsSH = { xaxis: { categories: playersSH } }
              this.$refs.apex_to_sh_chart.updateOptions(newOptionsSH)
            },
            response => {}
          )
      }
    },
    resetData () {
      this.apex_to_chart[0].data = []
    }
  },
  mounted: function () {
    // console.log('Fetch Turnovers: ' + this.gameId)
    this.fetchTurnoversChart()
  }
}
</script>
<style lang='scss' scoped>

.segment {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.small-box {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 100%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.segment h1 {
  color: black;
  text-shadow: 0px 1px 1px #8b0505d1;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-top:0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}
.segment h2 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 2em;
}
.segment p{
  font-size:1.2em;
  text-transform: uppercase;
}
.stat-title{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.3rem;
  margin: 1rem 0rem;
}
.stat-category{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.5rem;
  margin: 1rem 0rem;
}
.stat-number{
  font-family: 'Heebo', sans-serif;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.3rem;
  margin: 1rem 0rem;
  color:black;
}
</style>



// WEBPACK FOOTER //
// match-turnovers.vue?3ad86778